import { Md5 } from "md5-typescript";

const md5Cipher = (password: string) => {
  let salt = "dsyrwehjs";
  let user_ticket = Md5.init(Md5.init(salt) + Md5.init(password));
  return user_ticket;
};

export { md5Cipher };
